import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.55 12.05c-.19-.437-.136-.956.22-1.312C5.137 9.371 8.035 7.375 12 7.375c3.938 0 6.836 1.996 8.203 3.363.356.356.41.875.219 1.313l-1.149 2.57c-.164.383-.574.574-.984.492l-2.98-.574c-.41-.082-.684-.437-.684-.875v-2.351a8.6 8.6 0 0 0-5.25 0v2.351c0 .438-.3.793-.71.875l-2.981.574c-.41.082-.82-.11-.985-.492z"
    }, null, -1)
  ]))]))
}
export default { render: render }